// extracted by mini-css-extract-plugin
export default {"card":"style_card__PfBSm","details":"style_details__WY5X4","imgWrapper":"style_imgWrapper__kZOrB","count":"style_count__McwGr","title":"style_title__nBNCT"};